
import { RevCard } from '@ds/components/Card'
import { mapGetters } from 'vuex'

import {
  getAdvertisingOptionsFromComponent,
  searchPaymentAdvertising,
} from '@payment'

export default {
  components: {
    RevCard,
  },

  computed: {
    ...mapGetters({
      paymentMethods: 'countryConfig/paymentMethods',
    }),

    advertising() {
      return searchPaymentAdvertising(
        this.paymentMethods,
        getAdvertisingOptionsFromComponent(this),
      )
    },
  },
}
